import React from 'react'
import classes from "./styles.module.scss";
import PulseIndicator from '../PulseIndicator';
import { useNavigate, NavLink } from "react-router";

export interface QuickTitleProps extends React.InputHTMLAttributes<HTMLInputElement> {
    text?: string;
    link?: string;
}

const QuickTitle: React.FC<QuickTitleProps> = ({ text, link="/" }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/");
    }
    return (
        <NavLink to={link} className={classes.QuickTitle} onClick={handleClick}>
            <PulseIndicator color='black' />
            <div className={classes.titleText}>{text}</div>
        </NavLink>
    )
}

export default QuickTitle